import api from './client';

export interface CalcProduto {
  IdTry?: string;
  Descricao?: string;
  Quantidade?: string;
  ContaEstoque?: string;
  Tipo?: string;
}

export interface CalcPedido {
  IdPedidoBanco?: string;
  IdCliente?: string;
  Nome?: string;
  NumeroProposta?: string;
  DataProposta?: string;
  DataValidadeProposta?: string;
  Data?: string;
  Produtos?: string | CalcProduto[];
  ValorTotalPedido?: number | string;
  ValorTotalDescontado?: string;
  PotenciaProjeto?: number;
  MarcaInversor?: string;
  MarcaModulo?: string;
  PotenciaInversor?: string;
  PotenciaModulo?: string;
  QuantidadeInversor?: string;
  QuantidadeModulo?: string;
  KitFechado?: string;
  Empresa?: string;
  TipoTelhado?: string;
  estoqueIndisponivel?: string[] | null;
}

export async function buscarPedidosCalc(idCliente: string): Promise<CalcPedido[]> {
  const res = await api.get('/crm/pedidos', { params: { IdCliente: idCliente } });
  return res.data?.pedidos || [];
}
